import { roadmapTypes } from "./roadmap.types";

const INITIAL_STATE = {
  roadmap: {
    data: null,
  },
};

const roadmapReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //
    case roadmapTypes.SET_ROADMAP_DATA:
      return {
        ...state,
        roadmap: {
          data: action.payload,
        },
      };

    default:
      return state;
  }
};

export default roadmapReducer;
